import { useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';

export const usePrefetchSellers = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['sellers', { ...filters, page: String(nextPage) }],
        queryFn: () => sellerServices.getSellers({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['sellers', { ...filters, page: String(prevPage) }],
        queryFn: () => sellerServices.getSellers({ ...filters, page: String(prevPage) }),
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
